import React, { useCallback, useEffect } from 'react'
import { connect } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { Dispatch } from 'redux'
import { Loader } from 'semantic-ui-react'
import { getAccountDetails, getCorrespondent, postTransaction } from '../../actions'
import { RootState } from '../../store'
import { AccountDetails, Correspondent } from '../../types'
import TradeFormWrapper from '../TradeForm/TradeFormWrapper'
import { SubmissionPayload } from '../TradeForm/Types'

export interface TradeEntryPageProps {
  accountDetails?: AccountDetails
  correspondent: Correspondent
  getAccountDetails: (accountNumber: string) => void
  getCorrespondent: (accountNumber: string) => void
  postTransaction: (payload: SubmissionPayload, successCallback: () => void) => void
  tradeSubmissionFailedMessage?: string
}

export const TradeEntryPage = (props: TradeEntryPageProps) => {
  const { accountDetails, getAccountDetails, getCorrespondent, correspondent } = props
  const history = useHistory()
  const { accountNumber } = useParams<{ accountNumber: string }>()

  useEffect(() => {
    if (!accountNumber) {
      history.push('/')
    }
  }, [history, accountNumber])

  const getFormPageInfo = () => {
    getAccountDetails(accountNumber)
    getCorrespondent(accountNumber)
  }

  const getFormPageInfoMemo = useCallback(getFormPageInfo, [])

  useEffect(() => {
    getFormPageInfoMemo()
  }, [getFormPageInfoMemo])

  if (accountDetails && correspondent) {
    return <TradeFormWrapper {...props} accountDetails={accountDetails} />
  }
  return <Loader active>Loading Account</Loader>
}

const mapStateToProps = (state: RootState) => {
  const {
    accountDetailsReducer: { accountDetails },
    correspondentReducer: { correspondent },
    transactionReducer: { tradeSubmissionFailedMessage },
  } = state
  return { accountDetails, correspondent, tradeSubmissionFailedMessage }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getAccountDetails: (accountNumber: string) => getAccountDetails(dispatch, accountNumber),
  getCorrespondent: (accountNumber: string) => getCorrespondent(dispatch, accountNumber),
  postTransaction: (payload: SubmissionPayload, successCallback: () => void) =>
    postTransaction(dispatch, payload, successCallback),
})

export default connect(mapStateToProps, mapDispatchToProps)(TradeEntryPage)
